import { inject } from '@angular/core';
import { OrderStoreSelector } from '@common/selectors/order.selector';
import { combineLatest, map } from 'rxjs';

export const injectConfirmationPageContext = (orderStoreSelector = inject(OrderStoreSelector)) => ({
  confirmationPage: combineLatest({
    /**
     * Availability: On the order confirmation page
     * Content: The confirmed order data
     * Example: { id: '123', name: 'MyPizzaShop', slug... }
     * Usage: {{'{{confirmationPage.shop.name}}'}} => MyPizzaShop
     */
    shop: orderStoreSelector.selectActive.pipe(map(order => order?.shop)),
  }),
});
